import { render, staticRenderFns } from "./ContactDetailModal.vue?vue&type=template&id=5329eebd&scoped=true&"
import script from "./ContactDetailModal.vue?vue&type=script&lang=js&"
export * from "./ContactDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailModal.vue?vue&type=style&index=0&id=5329eebd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5329eebd",
  null
  
)

export default component.exports